/**
 * @desc 获取多店铺报告列表
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartItemsReport/getReport`, {
      method: "GET",

      ...options,
    }),
  );
}
